const enum SupportedTypes {
  NEWS_ARTICLE = "NewsArticle",
  FAQ_PAGE = "FAQPage",
  VIDEO_OBJECT = "VideoObject",
  BREADCRUMB_LIST = "BreadcrumbList",
  LIST_ITEM = "ListItem",
}

export default SupportedTypes;
